import React from "react";
import PropTypes from "prop-types";
import { removeHTMLFromString } from "../../../helpers/domHelpers";

const HiddenInput = ({ name, value, stringify, useUnsafeString }) => {
  // bypass explicit undefined or null passed in.
  // see https://stackoverflow.com/a/43519507/3148807

  let toRender;
  if (stringify) {
    toRender = Object.entries(value).map(([key, val], idx) => {
      const safeValue = useUnsafeString ? val : removeHTMLFromString(val);
      return (
        <input
          type="hidden"
          name={`${name}.${key}`}
          value={safeValue}
          key={`${key}${safeValue}${idx}`}
        />
      );
    });
  } else {
    const noneNullVal = useUnsafeString
      ? value
      : removeHTMLFromString(value) || "";
    toRender = <input type="hidden" name={name} value={noneNullVal} />;
  }
  return <React.Fragment>{toRender}</React.Fragment>;
};

HiddenInput.defaultProps = {
  value: ""
};

HiddenInput.propTypes = {
  name: PropTypes.string,

  /* stringify will extract all keys and will return name.key = value
    for example:
    given this props name="SelectedOption" value={{value: 218, optionType: 'Hotel'}}
    we will get: 
    <input type="hidden" name="SelectedOption.value" value="218" />
    <input type="hidden" name="SelectedOption.optionType" value="Hotel" />
  */
  stringify: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
    PropTypes.bool
  ]),
  useUnsafeString: PropTypes.bool
};

export default HiddenInput;



// WEBPACK FOOTER //
// ./src/components/common/HiddenInput/HiddenInput.js